import {Component, OnInit} from '@angular/core';
import Commons from "../../commons";
import {AuthRESTService} from "../../../services/rest/auth-rest.service";
import {Partner} from "../../../../models/partner";
import { ToastrService } from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import { AppWidgetModule } from 'app/components/widgets/widget.module';
import { SharedModule } from 'app/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule, AppWidgetModule],
    selector: 'app-partner-create',
    templateUrl: './partner-create.component.html',
    styleUrls: ['./partner-create.component.css']
})
export class PartnerCreateComponent extends Commons implements OnInit {
    partner: Partner = new Partner();
    base64: { value: string } = { value: '' };
    allowedFileTypes: string = "image/x-png";
    errorMessage = '';

    constructor(private rest: AuthRESTService, toastr: ToastrService, translate: TranslateService) {
        super(toastr, translate);
    }

    ngOnInit() {
    }

    save(): void {
        this.partner.base64 = this.base64.value;
        this.rest.post('configuration/partners', this.partner).subscribe(() => {
                this.clearNotifications().addSuccess('general.saved');
                this.errorMessage = '';
            }, err => this.errorHandler(err)
        )
    }

}
